import React, { useContext } from 'react';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { StepContainer, FinishView } from '@bingads-webui-campaign-react/goal-creation-wizard';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { UetSetupWizardContext } from '../../uet-setup-wizard-context';
import { getwebInsightsGraphStyle } from '../../styles/uet-insights-styles';

const FinishStepUnwrapped = (props) => {
  const i18n = useContext(I18nContext);
  const { children, permissions, serverContext } = props;
  const wizardContext = useContext(UetSetupWizardContext);
  const styleClass = useDefaultStyles(getwebInsightsGraphStyle, {});
  const { AdvertiserCustomerID: cid, Id: aid } = serverContext.CurrentAccount;
  const conversionGoalsPageLink = document.URL.replace(/vnext.*$/, `vnext/conversiongoals?cid=${cid}&aid=${aid}`);
  const audiencesLibraryPageLink = document.URL.replace(/vnext.*$/, `vnext/audienceslibrary?cid=${cid}&aid=${aid}`);

  const footerConfig = {
    buttons: [
      {
        type: 'Primary',
        onClick: () => wizardContext.exitWizard(true), // Done button clicked!
        isEnabled: true,
        text: i18n.getString(_TL_('Done')),
      },
    ],
  };

  const webInsightsInstructionText = {
    TopText: _TL_('Next steps for your UET Tag'),
    Step1Body: _TL_('Test your tag to see if it\'s installed properly'),
    Step2Body: _TL_('{{c}}Create a conversion goal{{/c}} or {{a}}audience{{/a}}'),
    Step3Body: _TL_('See how your customers engage with your website through UET Insights'),
  };

  return (
    <React.Fragment>
      <StepContainer
        title={i18n.getString(_TL_('All done!'))}
        step="end-flow"
        footerConfig={footerConfig}
      >
        <FinishView
          i18n={i18n}
          serverContext={wizardContext.serverContext}
          gtmContext={wizardContext.GTMContext}
        />
        {permissions.dynamic.UETTagInsights &&
          <div className={classNames('webInsights-graph-instruction-container', styleClass.webInsightsInstructionGraph)}>
            <div className="webInsights-graph-paragraph-top">
              {i18n.getString(webInsightsInstructionText.TopText)}
            </div>
            {children}
            <div className="webInsights-graph-container">
              <div className="webInsights-graph-item">
                <div className="webInsights-graph-step-1" />
                <div className="webInsights-graph-step-1-body">{i18n.getString(webInsightsInstructionText.Step1Body)}</div>
              </div>
              <div className="webInsights-graph-item">
                <div className="webInsights-graph-step-2" />
                <div className="webInsights-graph-step-2-body">
                  <ReactTemplate
                    model={{
                      c: text => (<a href={conversionGoalsPageLink}>{text}</a>),
                      a: text => (<a href={audiencesLibraryPageLink}>{text}</a>),
                    }}
                    template={i18n.getString(webInsightsInstructionText.Step2Body)}
                  />
                </div>
              </div>
              <div className="webInsights-graph-item">
                <div className="webInsights-graph-step-3" />
                <div className="webInsights-graph-step-3-body">{i18n.getString(webInsightsInstructionText.Step3Body)}</div>
              </div>
            </div>
          </div>}
      </StepContainer>
    </React.Fragment>
  );
};

export const FinishStep = FinishStepUnwrapped;
